var map = {
	"./brookwaterlife/logo-new.png": 147,
	"./brookwaterlife/logo.png": 148,
	"./current/logo-new.png": 147,
	"./current/logo.png": 148,
	"./default/chat-bubble 2.png": 149,
	"./default/chat-bubble.png": 150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;